import getOptionsFromPrefix from '../helpers/getOptionsFromPrefix';

import edit from './Media/Edit';
import upload from './Media/Upload';
import sidebar from './Media/Sidebar';
import filter from './Media/Filter';
import search from './Media/Search';
import selection from './Media/Selection';
import albums from './Media/Albums';
import pagination from './Media/Pagination';

const Media = {
  /**
   * Create Media element
   * @param {HTMLElement} node
   * @param {Object} props
   * @return {Void}
   */
  create(node, props) {
    // Load plugins for Media, can't do this at the top of the file because of missing $

    // Extend the default options with any given inline options with data attributes
    const options = Object.assign({}, getOptionsFromPrefix(props, 'media'));

    this.edit = edit.create(node, options);
    this.upload = upload.create();

    if (options.full) {
      this.sidebar = sidebar.create(node);
      this.filter = filter.create(node, options);
      this.search = search.create(node);
      this.selection = selection.create(node, options);
      this.albums = albums.create(node, options);
      this.pagination = pagination.create(node, options);
    }
  },
};

export default Media;
